var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { RadioGroup } from "@headlessui/react";
export var RadioStyle;
(function (RadioStyle) {
    RadioStyle[RadioStyle["Colorful"] = 0] = "Colorful";
    RadioStyle[RadioStyle["Gray"] = 1] = "Gray";
})(RadioStyle || (RadioStyle = {}));
export var Radio = function (_a) {
    var items = _a.items, value = _a.value, setValue = _a.setValue, style = _a.style, className = _a.className, disabled = _a.disabled;
    return (_jsx(RadioGroup, __assign({ className: "flex flex-row items-center ".concat(style == RadioStyle.Gray ? "bg-black-1200" : "bg-black-1000", " rounded-[10px] w-fit h-fit ").concat(className !== null && className !== void 0 ? className : "", " ").concat(disabled ? "opacity-50 pointer-events-none" : ""), value: value, onChange: setValue }, { children: items.map(function (item) {
            return (_jsx(RadioGroup.Option, __assign({ value: item.value }, { children: function (_a) {
                    var checked = _a.checked;
                    return (_jsx("button", __assign({ className: "px-[24px] py-[16px] font-N10 rounded-[10px] ".concat(checked
                            ? "".concat(style == RadioStyle.Gray
                                ? "bg-black-800"
                                : "bg-gradient-to-r from-main-gradient-from to-main-gradient-to", " text-white ").concat(disabled ? "" : "hover:text-black-200")
                            : "".concat(style == RadioStyle.Gray
                                ? "bg-black-1200"
                                : "bg-black-1000", " text-black-400 ").concat(disabled ? "" : "hover:bg-black-800 hover:text-white")), disabled: disabled }, { children: item.name })));
                } }), item.name));
        }) })));
};
export var OnOffRadio = function (_a) {
    var on = _a.on, setOn = _a.setOn, className = _a.className, disabled = _a.disabled, childProps = __rest(_a, ["on", "setOn", "className", "disabled"]);
    var items = [
        {
            name: "OFF",
            value: false,
        },
        {
            name: "ON",
            value: true,
        },
    ];
    return (_jsx(Radio, __assign({ items: items, setValue: setOn, value: on, style: RadioStyle.Gray, className: className }, childProps, { disabled: disabled })));
};
